.pdpWeightSelector {
  margin-bottom: 24px;
}

.pdpQuantitySelectorContainer {
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 12px;

  :global(#popover-content) {
    width: 100%;
    max-height: 360px;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }
}

.pdpQuantitySelector {
  width: 98px;
  padding: 0;
}

.pdpAddToCartBtnContainer {
  width: 273px;
  white-space: nowrap;
}

.textContrastColor {
  color: var(--colors-text-inverse);
}

@media all and (--reefer-media-tablet-min) {
  .pdpWeightSelector {
    margin-bottom: 16px;
  }

  .pdpQuantitySelectorContainer {
    :global(#popover-content) {
      width: 98px;
    }
  }
}
